<template>
  <div class="sidebar">
    <!-- 顶部图标按钮区域 -->
    <div class="sidebar-top">
      <div class="sidebar-item" @click="handleHome" title="首页">
        <i class="el-icon-house"></i>
      </div>
      <div
        v-for="tool in tools"
        :key="tool.pageKey"
        class="sidebar-item"
        @click="handleTool(tool)"
        :title="tool.pageTitle"
      >
        <i :class="tool.icon"></i>
      </div>
    </div>

    <!-- 底部新手引导按钮 -->
    <div class="sidebar-bottom">
      <div
        id="nipponia-web-start"
        class="sidebar-guide-btn"
        @click="toggleShowStart(true)"
        title="新手引导"
      >
        <i class="el-icon-question"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { createMicroApp } from '@/config/microAppConfig.js'
import showCurrentApp from '@/utils/showCurrentApp.js'
import api from 'api/module/role'
import { mapState } from 'vuex'

export default {
  inject: ['toggleShowStart'],
  name: 'SideBar',
  computed: {
    ...mapState(['tabs','currentOrg','keycloakToken']),
  },
  data() {
    return {
      tools: [],
    }
  },
  async created(){
      this.fetchTools()
  },

  watch: {
    keycloakToken: {
      handler(newVal) {
        if (newVal && newVal.tokenParsed) {
          this.fetchTools()
        }
      },
      immediate: false,
      deep: true
    },
    currentOrg: {
      handler(newVal) {
        if (newVal && newVal.id && newVal.orgCode) {
          this.fetchTools()
        }
      },
      immediate: false,
      deep: true
    },
  },

  methods: {
    async fetchTools() {
      // 只有keycloakToken有值时才请求
      if (
        !this.currentOrg ||
        !this.currentOrg.id ||
        !this.currentOrg.orgCode ||
        !this.keycloakToken ||
        !this.keycloakToken.tokenParsed
      ) {
        return
      }
      await api({
        name: 'getToolsById',
        data: {
          orgId: this.currentOrg.id,
          orgCode: this.currentOrg.orgCode,
          accId: this.keycloakToken.tokenParsed.sub,
        },
        _this: this,
      }).then((response) => {
        this.tools = response.data.resultBody.tools || []
      })
    },
    openLink(page) {
      console.log(page, '测试jade')
      createMicroApp({
        ...page,
        pageUrl: page.pageUrl,
      }).then(async (res) => {
        await this.$tabs.openTab({
          // TODO：非body里面（即导航目录里面）的内容，加上这个标志，不然报错
          isElectronSideApp: true,
          title: page.pageTitle,
          titleParent: [],
          path: page.pageUrl,
          query: {},
        })
        this.$nextTick(() => {
          showCurrentApp()
        })
      })
    },
    async handleHome() {
      const homeTab = this.tabs.find(tab => tab.title === '首页')
      if (homeTab) {
        await this.$tabs.switchTab(homeTab)
      } else {
        console.log('未找到首页 tab')
      }
    },
    handleTool(tool) {
      // 这里可以根据 tool 信息做跳转或其他操作
      this.openLink({
        applicationName: tool.applicationName,
        pageKey: tool.pageKey,
        pageName: tool.pageName,
        status: tool.status,
        pageUrl: tool.pageUrl,
        pageTitle: tool.pageTitle,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.sidebar {
  width: 60px;
  height: 100%;
  background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);

  &-top {
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &-item {
    width: 44px;
    height: 44px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.3s ease;
    color: #bdc3c7;

    i {
      font-size: 20px;
    }

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      color: #ffffff;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    &.active {
      background-color: #3498db;
      color: #ffffff;
      box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3);
    }
  }

  &-bottom {
    padding-bottom: 20px;
  }

  &-guide-btn {
    width: 44px;
    height: 44px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.3s ease;
    color: #e74c3c;
    background-color: rgba(231, 76, 60, 0.1);
    border: 1px solid rgba(231, 76, 60, 0.3);

    i {
      font-size: 18px;
      margin-bottom: 4px;
    }

    .guide-text {
      font-size: 10px;
      font-weight: 600;
      line-height: 1;
      text-align: center;
    }

    &:hover {
      background-color: #e74c3c;
      color: #ffffff;
      border-color: #e74c3c;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(231, 76, 60, 0.3);
    }
  }
}
</style>
